import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import PrivateRoute from "./components/PrivateRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import PublicRoute from "./components/PublicRoute";

import Login from "./pages/Login";
import Projects from "./pages/Projects";
import Register from "./pages/Register";
import Teams from "./pages/Teams";

function App() {
    const authChecked = useAuthCheck();
    return !authChecked ? (
        <div>Checking authentication....</div>
    ) : (
        <Router>
            <Routes>
                <Route path="/" element={
                <PublicRoute>
                <Login />
                </PublicRoute>
                } />
                <Route path="/register" element={
                <PublicRoute>
                <Register />
                </PublicRoute>
                } />
                <Route path="/projects" element={

                    <PrivateRoute>
                        <Projects />
                    </PrivateRoute>
                } />
                <Route path="/teams" element={
                    <PrivateRoute>
                        <Teams />
                    </PrivateRoute>
                } />
            </Routes>
        </Router>
    );
}

export default App;